import { type FC, useState } from "react";
import {
  Chip,
  Flex,
  GalleryCarousel,
  Image,
  Modal,
  Text,
  Tooltip,
} from "@huub-web/ui";
import { ucfirst } from "@huub-web/utils";

import type { AnalysisObservation } from "../../../types";
import { imageContainerStyle, imageStyle } from "./AnalysisListItem.css";
import { Tip } from "../../Tip/Tip";

export type AnalysisListItemProps = {
  observation: AnalysisObservation;
};

export const AnalysisListItem: FC<AnalysisListItemProps> = ({
  observation,
}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const media = observation.resolvedMediaReferences?.filter(
    (media) => !!media.url,
  );

  return (
    <>
      <Flex direction="column" gap="s">
        <Flex gap="s" justify="space-between">
          <Flex direction="column" gap="xs">
            <Flex gap="s">
              <Text bold>{ucfirst(observation.component)}</Text>
              <Chip variant="tertiary">{observation.assessment}</Chip>
            </Flex>
            <Text variant="bodyS" markdown>
              {observation.explanation}
            </Text>
          </Flex>
          {media && media.length > 0 && (
            <div className={imageContainerStyle}>
              <Tooltip value="Relevante media">
                <Image
                  onClick={() => setIsModalOpen(true)}
                  className={imageStyle}
                  borderRadius
                  src={media[0].url ?? ""}
                  alt={media[0].reference ?? ""}
                />
              </Tooltip>
            </div>
          )}
        </Flex>
        {observation.improvementAdvice && (
          <Tip name="Advies">{observation.improvementAdvice}</Tip>
        )}
      </Flex>

      {isModalOpen && (
        <Modal
          escape
          closeable
          onClose={() => setIsModalOpen(false)}
          title={
            <Flex gap="s">
              <Text bold>{ucfirst(observation.component)}</Text>
              <Chip variant="tertiary">{observation.assessment}</Chip>
            </Flex>
          }
        >
          {media && media.length > 0 && (
            <GalleryCarousel
              items={observation.resolvedMediaReferences
                .filter((media) => !!media.url)
                .map(({ url, reference }) => ({
                  url: url ?? "",
                  reference,
                }))}
            />
          )}
          <Flex direction="column" gap="xs">
            <Text variant="bodyS" markdown>
              {observation.explanation}
            </Text>
          </Flex>
          {observation.improvementAdvice && (
            <Tip name="Advies">{observation.improvementAdvice}</Tip>
          )}
        </Modal>
      )}
    </>
  );
};
